// extracted by mini-css-extract-plugin
module.exports = {"company":"styles_company__12nM1","companyName":"styles_companyName__rlYjR","offices":"styles_offices__RYXBc"};